import React from 'react';
import { Link } from 'react-router-dom';
import ShieldLogo from './ShieldLogo';

/**
 * Wordmark with the shield icon — used in standalone page headers
 * (auth flows, dashboard, wizard, etc.) where the full nav isn't rendered.
 */
const Wordmark = ({ size = 24, textClassName = 'text-2xl', testId }) => (
  <Link
    to="/"
    data-testid={testId}
    className="inline-flex items-center gap-2 hover:opacity-70 transition-opacity"
  >
    <ShieldLogo size={size} />
    <span
      className={`${textClassName} font-semibold`}
      style={{ fontFamily: 'Instrument Serif, serif' }}
    >
      Verilock
    </span>
  </Link>
);

export default Wordmark;
